import React from 'react'

const Thunder = props => (
  <svg viewBox="0 0 49 65" {...props}>
    <path d="M48.5 0L20.7.1c-.2 0-.3.1-.4.2L.1 32.8c-.2.3 0 .7.4.7h19.2c.4 0 .6.4.4.7l-15 30.1c-.1.5.5.9.9.6L44.8 26c.3-.3.1-.8-.3-.8H25.9c-.4 0-.6-.5-.3-.8L48.9.8c.3-.3 0-.8-.4-.8z" />
  </svg>
)

export default Thunder